import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {

  const router = useRouter()

  const { public: config } = useRuntimeConfig()

  const { dsn } = config.sentry

  if (!dsn) {
    return
  }

  const ignoreRegexErrors = [
    /GET.*[401|403]/,
  ]

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn,
    environment: config.env,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    beforeSend(event, hint) {
      const error = hint.originalException

      if (error?.message) {
        for (const regex of ignoreRegexErrors) {
          if (error.message.match(regex)) {
            return null
          }
        }
      }
      return event
    }
  })
})
